import React from "react";
import PhotographersList from "./PhotographersList";
import useFilteredPhotographers from "./useFilteredPhotographers";

const PhotographerResults = ({
  photographer
}: {
  photographer: string | null;
}) => {
  const { error, loading, photographers } = useFilteredPhotographers(photographer);
  const renderNothing = photographer === null;

  if (renderNothing) return null;
  else return <PhotographersList loading={loading} photographers={photographers} />;
};
export default PhotographerResults;
